import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useState } from 'react'

const navItems = [
  'Suppliers',
  'Carriers',
  'Retailers',
  'Wholesalers',
  'Customers',
]

export const HeroSection = () => {
  return (
    <section className='relative h-[70vh] flex flex-col'>
      {/* Main Content Container - Full width with padding */}
      <div className='relative z-20 flex-1 flex items-end w-full px-8 pb-24'>
        <div className='grid grid-cols-12 gap-4 w-full max-w-[1920px] mx-auto'>
          {/* Side Navigation - Column 1-3 */}
          <div className='col-span-3 hidden lg:flex items-end'>
            <nav className='flex flex-col gap-3'>
              {navItems.map((item, index) => (
                <button
                  key={index}
                  className='group text-right text-xl font-medium text-white hover:text-white/80 transition-all duration-300 flex items-center justify-end gap-4'
                >
                  <span>{item}</span>
                  <svg
                    className='w-6 h-6 opacity-70 group-hover:opacity-100 group-hover:translate-x-2 transition-all duration-300'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2.5}
                      d='M17 8l4 4m0 0l-4 4m4-4H3'
                    />
                  </svg>
                </button>
              ))}
            </nav>
          </div>

          {/* Hero Text - Column 4-12 */}
          <div className='col-start-4 col-span-9'>
            <h1
              className='text-[5.5rem] font-medium tracking-tight leading-none text-[#EBF0FF]'
              style={{ fontWeight: 500 }}
            >
              The silo-breaking data platform{' '}
              <span className='text-white font-bold'>connecting fuel</span>
            </h1>
          </div>
        </div>

        {/* Bottom row with badges - positioned at bottom of hero */}
        <div className='absolute bottom-8 left-0 right-0 px-8'>
          <div className='grid grid-cols-12 gap-4 w-full max-w-[1920px] mx-auto'>
            <div className='col-span-4 text-sm text-[#9687F5] font-medium'>
              TULSA, OK
            </div>

            {/* Copyright Badge - Right aligned */}
            <div className='col-start-9 col-span-4 text-right text-sm text-[#9687F5] font-medium'>
              ©2025
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export const HeroBottomSection = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [emailValue, setEmailValue] = useState('')
  const [messageValue, setMessageValue] = useState('')
  const [emailError, setEmailError] = useState('')

  return (
    <section className='relative z-20 border-t border-white/10 py-16'>
      <div className='w-full px-8'>
        <div className='grid grid-cols-12 gap-4 w-full max-w-[1920px] mx-auto'>
          {/* Social - Left side */}
          <div className='col-span-3 flex items-center gap-4'>
            <span className='text-xs text-white/60 uppercase tracking-wider'>
              Follow us on
            </span>
            <div className='flex gap-3'>
              <a
                href='#'
                className='text-white/60 hover:text-white transition-colors'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path d='M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z' />
                </svg>
              </a>
              <a
                href='#'
                className='text-white/60 hover:text-white transition-colors'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' />
                </svg>
              </a>
              <a
                href='#'
                className='text-white/60 hover:text-white transition-colors'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' />
                </svg>
              </a>
            </div>
          </div>

          {/* Description - Starting at column 4 */}
          <div className='col-start-4 col-span-5'>
            <p className='text-base text-white/60'>
              Connect to the intelligent data hub connecting fuel suppliers,
              wholesalers, retailers, carriers, and customers. All the data you
              need for real-time decision making.
            </p>
          </div>

          <div className='col-span-3 flex justify-end'>
            <div>
              <Button
                size='lg'
                className='bg-white text-black hover:bg-white/90 text-base px-8 py-3 font-medium'
                onClick={() => setIsPopoverOpen(true)}
              >
                See a Demo →
              </Button>
              {isPopoverOpen && (
                <>
                  <div
                    className='fixed inset-0 z-40 bg-black/50 backdrop-blur-sm'
                    onClick={() => setIsPopoverOpen(false)}
                  />
                  <div className='fixed inset-0 z-50 flex items-center justify-center px-4'>
                    <div className='w-full max-w-md rounded-2xl border border-white/20 bg-white/95 p-6 shadow-2xl backdrop-blur'>
                      <h3 className='text-lg font-semibold text-gray-900 mb-3'>
                        Request Demo Access
                      </h3>
                      <form
                        onSubmit={(event) => {
                          event.preventDefault()
                          if (!emailValue.trim()) {
                            setEmailError('Email is required')
                            return
                          }
                          console.log(
                            'this will send an email to joel.davies@gravitate.energy',
                            {
                              email: emailValue.trim(),
                              comment: messageValue.trim() || undefined,
                            },
                          )
                          setIsPopoverOpen(false)
                          setEmailValue('')
                          setMessageValue('')
                          setEmailError('')
                        }}
                      >
                        <div className='space-y-4'>
                          <div className='space-y-2'>
                            <label className='text-sm font-medium text-gray-700'>
                              Your Email
                            </label>
                            <Input
                              type='email'
                              value={emailValue}
                              onChange={(event) => {
                                setEmailValue(event.target.value)
                                if (emailError) {
                                  setEmailError('')
                                }
                              }}
                              placeholder='you@example.com'
                              className='bg-[#221a43] text-white/80 placeholder:text-white/60 border-[#7C6EF0] focus-visible:ring-[#9687F5]'
                            />
                            {emailError && (
                              <p className='text-sm text-red-500'>
                                {emailError}
                              </p>
                            )}
                          </div>
                          <div className='space-y-2'>
                            <label className='text-sm font-medium text-gray-700'>
                              Comment
                            </label>
                            <textarea
                              value={messageValue}
                              onChange={(event) =>
                                setMessageValue(event.target.value)
                              }
                              placeholder='Add any context for the demo request'
                              className='w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 focus:border-gray-400 focus:outline-none focus:ring-0'
                              rows={4}
                            />
                          </div>
                          <div className='flex items-center justify-end gap-3'>
                            <Button
                              type='button'
                              variant='ghost'
                              className='text-gray-600 hover:bg-gray-100'
                              onClick={() => {
                                setIsPopoverOpen(false)
                                setEmailValue('')
                                setMessageValue('')
                                setEmailError('')
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              type='submit'
                              className='bg-[#9687F5] text-white hover:bg-[#8073e8]'
                            >
                              Send Request
                            </Button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
